import produce from 'immer'
import { Reducer } from 'redux'
import { history } from '../../routes/services/history'
import { EditBasicInformationSuccess } from './editActions'
import {
  Address,
  Coupon,
  EditEvent,
  EventActions,
  EventItems,
  EventState,
  Tickets
} from './types'
import { Pixels } from '../../api/events/updateEventPixelsService'

const INITIAL_STATE: EventState = {
  steps: [
    {
      name: 'Informações básicas',
      position: 1,
      completed: false,
      isActive: true
    },
    {
      name: 'Descrição do Evento',
      position: 2,
      completed: false,
      isActive: false
    },
    {
      name: 'Localização',
      position: 3,
      completed: false,
      isActive: false
    },
    {
      name: 'Sessões',
      position: 4,
      completed: false,
      isActive: false
    },
    {
      name: 'Ingressos',
      position: 5,
      completed: false,
      isActive: false
    },
    {
      name: 'Cupons',
      position: 6,
      completed: false,
      isActive: false
    },
    {
      name: 'Marketing',
      position: 7,
      completed: false,
      isActive: false
    },
    {
      name: 'Publicar',
      position: 8,
      completed: false,
      isActive: false
    }
  ],
  editSteps: [
    {
      name: 'Informações básicas',
      position: 1,
      completed: false,
      isActive: true
    },
    {
      name: 'Descrição do Evento',
      position: 2,
      completed: false,
      isActive: false
    },
    {
      name: 'Localização',
      position: 3,
      completed: false,
      isActive: false
    },
    {
      name: 'Sessões',
      position: 4,
      completed: false,
      isActive: false
    },
    {
      name: 'Ingressos',
      position: 5,
      completed: false,
      isActive: false
    },
    {
      name: 'Cupons',
      position: 6,
      completed: false,
      isActive: false
    },
    {
      name: 'Marketing',
      position: 7,
      completed: false,
      isActive: false
    },
    {
      name: 'Publicar',
      position: 8,
      completed: false,
      isActive: false
    }
  ],
  data: []
}

export const EventReducer: Reducer<EventState> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case EventActions.clearState:
      return produce(state, (draft) => {
        draft.steps = INITIAL_STATE.steps
        draft.editSteps = INITIAL_STATE.editSteps
        draft.manageEvent = undefined
        draft.editEvent = undefined
      })
    case EventActions.stepBack:
      return produce(state, (draft) => {
        const actualStepIndex = draft.steps.findIndex(
          (step) => step.isActive === true
        )
        if (actualStepIndex !== -1) {
          draft.steps[actualStepIndex].isActive = false
          draft.steps[actualStepIndex - 1].isActive = true
        }
      })
    case EventActions.nextStep:
      return produce(state, (draft) => {
        const actualStepIndex = draft.steps.findIndex(
          (step) => step.isActive === true
        )
        if (
          actualStepIndex !== -1 &&
          actualStepIndex <= draft.steps.length - 1
        ) {
          draft.steps[actualStepIndex].isActive = false
          draft.steps[actualStepIndex + 1].isActive = true
        }
      })
    case EventActions.listEventsSuccess:
      return produce(state, (draft) => {
        draft.data = action.payload
        draft.editEvent = undefined
        draft.editSteps = INITIAL_STATE.editSteps
      })
    case EventActions.registerEventSuccess:
      return produce(state, (draft) => {
        if (draft.manageEvent) {
          draft.manageEvent.name = action.payload.name
          draft.manageEvent.category = action.payload.category
          draft.manageEvent.cashBackPercent = action.payload.cashBackPercent
          draft.manageEvent.banners = action.payload.banners
          draft.manageEvent.type = action.payload.type
          draft.manageEvent.seatMapId = action.payload.seatMapId
        } else {
          draft.manageEvent = action.payload
        }

        draft.steps[0].completed = true
        draft.steps[0].isActive = false
        draft.steps[1].isActive = true
      })
    case EventActions.addDescriptionSuccess:
      return produce(state, (draft) => {
        if (draft.manageEvent) {
          draft.manageEvent.description = action.payload
          draft.steps[1].completed = true
          draft.steps[1].isActive = false
          draft.steps[2].isActive = true
        }
      })
    case EventActions.editPixelsSuccess:
      return produce(state, (draft) => {
        if (draft.manageEvent) {
          draft.manageEvent.pixels = action.payload as Pixels
        }
        if (draft.editEvent) {
          draft.editEvent.pixels = action.payload as Pixels
        }
      })
    case EventActions.addLocationSuccess:
      return produce(state, (draft) => {
        if (draft.manageEvent) {
          draft.manageEvent.address = action.payload
        }
        if (draft.editEvent) {
          draft.editEvent.address = action.payload
        }
      })
    case EventActions.removeEventSuccess:
      return produce(state, (draft) => {
        const eventId: string = action.payload
        draft.data = state.data.filter((event) => event.id !== eventId)
        if (draft.manageEvent && draft.manageEvent.id === eventId) {
          draft.manageEvent = undefined
          draft.steps = INITIAL_STATE.steps
        }
      })
    case EventActions.createEventSuccess:
      return produce(state, (draft) => {
        draft.data.unshift(action.payload)
        draft.manageEvent = { ...action.payload, coupons: [] }
        draft.steps[2].completed = true
        draft.steps[2].isActive = false
        draft.steps[3].isActive = true
      })
    case EventActions.createEventItemSuccess:
      return produce(state, (draft) => {
        if (!history.location.pathname.includes('editEvent')) {
          if (draft.manageEvent!.eventItems) {
            draft.manageEvent!.eventItems!.push({
              ...action.payload,
              tickets: []
            })
          } else {
            draft.manageEvent!.eventItems = [{ ...action.payload, tickets: [] }]
          }
        } else {
          if (draft.editEvent!.eventItems) {
            draft.editEvent!.eventItems!.push({
              ...action.payload,
              tickets: []
            })
          } else {
            draft.editEvent!.eventItems = [{ ...action.payload, tickets: [] }]
          }
        }
      })
    case EventActions.removeEventItemSuccess:
      return produce(state, (draft) => {
        const eventItemId: string = action.payload
        if (history.location.pathname.includes('editEvent')) {
          const evenItemIndex = draft.editEvent!.eventItems?.findIndex(
            (eventItem) => eventItem.id === eventItemId
          )
          if (evenItemIndex !== -1) {
            draft.editEvent!.eventItems = draft.editEvent!.eventItems?.filter(
              (eventItem) => eventItem.id !== eventItemId
            )
          }
        } else {
          const evenItemIndex = draft.manageEvent!.eventItems?.findIndex(
            (eventItem) => eventItem.id === eventItemId
          )
          if (evenItemIndex !== -1) {
            draft.manageEvent!.eventItems =
              draft.manageEvent!.eventItems?.filter(
                (eventItem) => eventItem.id !== eventItemId
              )
          }
        }
      })

    case EventActions.addTicket:
      return produce(state, (draft) => {
        if (action.payload.actionTicket === 'create') {
          const indexItem = draft.editEvent
            ? draft.editEvent?.eventItems?.findIndex(
                (eventItem) =>
                  eventItem.id ===
                  action.payload.ticket.eventItems[0].eventItem.id
              )
            : draft.manageEvent?.eventItems?.findIndex(
                (eventItem) =>
                  eventItem.id ===
                  action.payload.ticket.eventItems[0].eventItem.id
              )

          if (indexItem! > -1 && draft.editEvent) {
            draft.editEvent?.eventItems![indexItem!].tickets.push({
              ...action.payload.ticket,
              eventItems: [{ ...action.payload.ticket.eventItems[0].eventItem }]
            })
          } else if (indexItem! > -1 && draft.manageEvent) {
            draft.manageEvent?.eventItems![indexItem!].tickets.push({
              ...action.payload.ticket,
              eventItems: [{ ...action.payload.ticket.eventItems[0].eventItem }]
            })
          }
        } else if (action.payload.actionTicket === 'edit') {
          const indexItemUpdate = draft.editEvent
            ? draft.editEvent?.eventItems?.findIndex(
                (eventItem) => eventItem.id === action.payload.eventItemId
              )
            : draft.manageEvent?.eventItems?.findIndex(
                (eventItem) => eventItem.id === action.payload.eventItemId
              )

          if (indexItemUpdate! > -1 && draft.editEvent) {
            const indexTicket = draft.editEvent?.eventItems![
              indexItemUpdate!
            ].tickets.findIndex(
              (ticket) => ticket.id === action.payload.ticket.id
            )

            if (indexTicket > -1) {
              draft.editEvent!.eventItems![indexItemUpdate!].tickets[
                indexTicket
              ] = {
                ...action.payload.ticket,
                eventItems: [
                  ...draft.editEvent!.eventItems![indexItemUpdate!].tickets[
                    indexTicket
                  ].eventItems
                ]
              }
            }
          } else if (indexItemUpdate! > -1 && draft.manageEvent) {
            const indexTicket = draft.manageEvent?.eventItems![
              indexItemUpdate!
            ].tickets.findIndex(
              (ticket) => ticket.id === action.payload.ticket.id
            )

            if (indexTicket > -1) {
              draft.manageEvent!.eventItems![indexItemUpdate!].tickets[
                indexTicket
              ] = {
                ...action.payload.ticket,
                eventItems: draft.manageEvent!.eventItems![indexItemUpdate!]
              }
            }
          }
        }
      })
    case EventActions.deleteTicket:
      return produce(state, (draft) => {
        const indexItem = draft.editEvent
          ? draft.editEvent?.eventItems?.findIndex(
              (eventItem) => eventItem.id === action.payload.eventItems[0].id
            )
          : draft.manageEvent?.eventItems?.findIndex(
              (eventItem) => eventItem.id === action.payload.eventItems[0].id
            )

        if (indexItem! > -1 && draft.editEvent) {
          const indexTicket = draft.editEvent?.eventItems![
            indexItem!
          ].tickets.findIndex((ticket) => ticket.id === action.payload.id)

          if (indexTicket! > -1) {
            draft.editEvent!.eventItems![indexItem!].tickets.splice(
              indexTicket!,
              1
            )
          }
        } else if (indexItem! > -1 && draft.manageEvent) {
          const indexTicket = draft.manageEvent?.eventItems![
            indexItem!
          ].tickets.findIndex((ticket) => ticket.id === action.payload.id)

          if (indexTicket! > -1) {
            draft.manageEvent!.eventItems![indexItem!].tickets.splice(
              indexTicket!,
              1
            )
          }
        }
      })
    case EventActions.deleteTicketSuccess:
      return produce(state, (draft) => {
        if (draft.manageEvent) {
          const ticketId: string = action.payload
          draft.manageEvent.tickets = draft.manageEvent.tickets?.filter(
            (ticket) => ticket.id !== ticketId
          )
        }
        if (draft.editEvent) {
          const ticketId: string = action.payload
          draft.editEvent.tickets = draft.editEvent.tickets?.filter(
            (ticket) => ticket.id !== ticketId
          )
        }
      })
    case EventActions.publishEvent:
      return produce(state, (draft) => {
        draft.steps = INITIAL_STATE.steps
        draft.manageEvent = undefined
        draft.editSteps = INITIAL_STATE.editSteps
        draft.editEvent = undefined
        history.push('/events')
      })
    case EventActions.editStepBack:
      return produce(state, (draft) => {
        const actualStepIndex = draft.editSteps.findIndex(
          (step) => step.isActive === true
        )
        if (actualStepIndex !== -1) {
          draft.editSteps[actualStepIndex].isActive = false
          draft.editSteps[actualStepIndex - 1].isActive = true
        }
      })
    case EventActions.editNextStep:
      return produce(state, (draft) => {
        const actualStepIndex = draft.editSteps.findIndex(
          (step) => step.isActive === true
        )
        if (
          actualStepIndex !== -1 &&
          actualStepIndex <= draft.editSteps.length - 1
        ) {
          draft.editSteps[actualStepIndex].isActive = false
          draft.editSteps[actualStepIndex + 1].isActive = true
        }
      })
    case EventActions.editBasicInformationSuccess:
      return produce(state, (draft) => {
        const {
          name,
          banners,
          seatMapId,
          category,
          cashBackPercent,
          ageGroup
        }: EditBasicInformationSuccess = action.payload
        if (draft.editEvent) {
          if (name) {
            draft.editEvent.name = name
          }
          if (ageGroup) {
            draft.editEvent.ageGroup = ageGroup
          }
          if (name) {
            draft.editEvent.name = name
          }
          if (banners) {
            draft.editEvent.banners = banners
          }
          if (category) {
            draft.editEvent.category = category
          }
          if (seatMapId) {
            draft.editEvent.seatMapId = seatMapId
          }
          if (cashBackPercent) {
            draft.editEvent.cashBackPercent = cashBackPercent
          }
        }
      })
    case EventActions.editDescriptionSuccess:
      return produce(state, (draft) => {
        const description: string = action.payload
        if (draft.editEvent) {
          draft.editEvent.description = description
        }
      })
    case EventActions.editAddressSuccess:
      return produce(state, (draft) => {
        const address: Address = action.payload
        if (draft.editEvent) {
          draft.editEvent.address = address
        }
      })
    case EventActions.editEventItemSuccess:
      return produce(state, (draft) => {
        const eventItemPayload: EventItems = action.payload
        if (history.location.pathname.includes('editEvent')) {
          const eventItemIndex = draft.editEvent!.eventItems!.findIndex(
            (eventItem) => eventItem.id === eventItemPayload.id!
          )
          if (eventItemIndex !== -1) {
            draft.editEvent!.eventItems![eventItemIndex] = {
              ...eventItemPayload,
              tickets: draft.editEvent!.eventItems![eventItemIndex].tickets
            }
          }
        } else {
          const eventItemIndex = draft.manageEvent!.eventItems!.findIndex(
            (eventItem) => eventItem.id === eventItemPayload.id!
          )
          if (eventItemIndex !== -1) {
            draft.manageEvent!.eventItems![eventItemIndex] = {
              ...eventItemPayload,
              tickets: draft.manageEvent!.eventItems![eventItemIndex].tickets
            }
          }
        }
      })
    case EventActions.editTicketSuccess:
      return produce(state, (draft) => {
        const ticketPayload: Tickets = action.payload

        if (history.location.pathname.includes('editEvent' || 'createEvent')) {
          const ticketIndex = draft.editEvent!.tickets.findIndex(
            (ticket) => ticket.id === ticketPayload.id
          )
          if (ticketIndex !== -1) {
            draft.editEvent!.tickets[ticketIndex] = ticketPayload
          }
        } else {
          const ticketIndex = draft.manageEvent!.tickets!.findIndex(
            (ticket) => ticket.id === ticketPayload.id
          )
          if (ticketIndex !== -1) {
            draft.manageEvent!.tickets![ticketIndex] = ticketPayload
          }
        }
      })
    case EventActions.loadEventSuccess:
      return produce(state, (draft) => {
        draft.editEvent = action.payload as EditEvent
        draft.editSteps = INITIAL_STATE.editSteps
      })
    case EventActions.goToStep:
      return produce(state, (draft) => {
        const position: number = action.payload
        const stepIndex = draft.editSteps.findIndex(
          (step) => step.position === position
        )
        draft.editSteps.forEach((step) => (step.isActive = false))
        draft.editSteps[stepIndex].isActive = true
      })
    case EventActions.createCouponSuccess:
      return produce(state, (draft) => {
        const coupon = action.payload as Coupon
        if (draft.editEvent) draft.editEvent.coupons.unshift(coupon)
        else if (draft.manageEvent) draft.manageEvent.coupons.unshift(coupon)
      })
    case EventActions.editCouponSuccess:
      return produce(state, (draft) => {
        const coupon = action.payload as Coupon
        if (draft.editEvent)
          draft.editEvent.coupons[
            draft.editEvent.coupons.findIndex(({ id }) => id === coupon.id)
          ] = coupon
        else if (draft.manageEvent)
          draft.manageEvent.coupons[
            draft.manageEvent.coupons.findIndex(({ id }) => id === coupon.id)
          ] = coupon
      })
    case EventActions.removeCouponSuccess:
      return produce(state, (draft) => {
        const couponId = action.payload as string
        if (draft.editEvent) {
          draft.editEvent.coupons = draft.editEvent.coupons.filter(
            ({ id }) => id !== couponId
          )
        } else if (draft.manageEvent) {
          draft.manageEvent.coupons = draft.manageEvent.coupons.filter(
            ({ id }) => id !== couponId
          )
        }
      })
    case EventActions.editSocialLinksSuccess:
      return produce(state, (draft) => {
        if (draft.editEvent) draft.editEvent.socialLinks = action.payload
      })
    default:
      return state
  }
}
